import {getUrlSearch} from '@/utils/getUrlSearch';
import useRequest from '.';

const PATH_PREFIX = process.env.NODE_ENV !== 'mock' ? '' : '/information';

const {p_client, did} = getUrlSearch();
export const requestNPS = () => useRequest<boolean>({
  method: 'post',
  url: `${PATH_PREFIX}/common/isNps`,
  data: {
    // 业务线, 咨询是1写死
    businessLine: 1,
    did,
    p_client
  }
});
